// Ensures the per-user favicon worker is deployed and returns its base URL.
// The worker runs in the signed-in user's own Puter account; its URL + version
// are cached in puter.kv. Returns null when Puter (workers/fs/kv) is unavailable
// or deploy fails — callers then fall back to the avatar. Never throws.

import { FAVICON_WORKER_SOURCE, FAVICON_WORKER_VERSION } from './favicon-worker-source.js';

const WORKER_NAME = 'pwvault-favicon';
const WORKER_FILE = 'pwvault-favicon-worker.js';
const KV_URL = 'pwvault:faviconWorkerUrl';
const KV_VER = 'pwvault:faviconWorkerVersion';

let _pending = null;

export async function ensureFaviconWorker() {
  const p = globalThis.puter;
  if (typeof p?.workers?.create !== 'function' ||
      typeof p?.fs?.write !== 'function' || !p?.kv) {
    return null;
  }
  if (!_pending) {
    _pending = deploy(p)
      .catch(() => null)
      .then((url) => { if (!url) _pending = null; return url; });
  }
  return _pending;
}

async function deploy(p) {
  try {
    const [url, ver] = await Promise.all([p.kv.get(KV_URL), p.kv.get(KV_VER)]);
    if (url && String(ver) === String(FAVICON_WORKER_VERSION)) return url;
  } catch { /* fall through to (re)deploy */ }

  await p.fs.write(WORKER_FILE, FAVICON_WORKER_SOURCE);

  let url = null;
  try {
    url = (await p.workers.create(WORKER_NAME, WORKER_FILE))?.url ?? null;
  } catch {
    try { await p.workers.delete(WORKER_NAME); } catch { /* ignore */ }
    try { url = (await p.workers.create(WORKER_NAME, WORKER_FILE))?.url ?? null; }
    catch { url = null; }
  }
  if (!url) return null;

  try {
    await p.kv.set(KV_URL, url);
    await p.kv.set(KV_VER, String(FAVICON_WORKER_VERSION));
  } catch { /* cache is best-effort */ }
  return url;
}
